import { Heading } from "@chakra-ui/react";
import PeopleTeamSettings from "features/Settings/PeopleTeam";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import InnerSidebar from "layouts/InnerSidebar";
import { useEffect } from "react";

export default function PeopleTeamSettingsPage() {
  const { setBackLocationPath, setBackLocationName, setPageTitle } = useNavbar();

  useEffect(() => {
    setPageTitle("People Team Settings");
    return () => {
      setBackLocationPath(null);
      setBackLocationName(null);
      setPageTitle(null);
    };
  }, [setBackLocationPath, setBackLocationName, setPageTitle]);

  return (
    <AppPage>
      <InnerSidebar>
        <Heading mb="8" size="sm" color="fg.subtle">
          People Team Settings
        </Heading>
        <PeopleTeamSettings />
      </InnerSidebar>
    </AppPage>
  );
}
